import React, { ReactNode, useMemo, useState } from 'react'
import type { FormProps as PCCFormProps } from '@interflora/ui-components/build/components/PCCModal/PCCModal'

type AvailabilityCheckerContextType = {
  formValues: PCCFormProps | null
  setFormValues: (values: PCCFormProps | null) => void
  /** Clears form values and resets to initial state (used by "Start again") */
  clearFormValues: () => void
}

const AvailabilityCheckerContext = React.createContext<AvailabilityCheckerContextType | null>(null)

AvailabilityCheckerContext.displayName = 'AvailabilityChecker'

export const AvailabilityCheckerProvider = ({ children }: { children: ReactNode }) => {
  const [formValues, setFormValues] = useState<PCCFormProps | null>(null)

  const value: AvailabilityCheckerContextType = useMemo(
    () => ({
      formValues,
      setFormValues,
      clearFormValues: () => setFormValues(null),
    }),
    [formValues]
  )

  return <AvailabilityCheckerContext.Provider value={value}>{children}</AvailabilityCheckerContext.Provider>
}

export default AvailabilityCheckerContext
